import {
	DEPARTAMENTOS, 
	CICLOS_ESCOLARES,
	INFO, 
	PLANES_ESTUDIO,
	CONJUNTO_PERIODOS,
	LABELS,
	ESTRUCTURA_CUSTOMNAMES,
	PARAMETROS
} from '../constants/Sistema';




const initState = {
  departamentos:null
}
const Sistema = (state = initState, action) => {
	switch (action.type) {
		case DEPARTAMENTOS:
			return {
				...state,
				departamentos: action.dptos
			}
        case CICLOS_ESCOLARES:
			return {
				...state,
				ciclos: action.ciclos
			}
		case PLANES_ESTUDIO:
			return {
				...state,
				planesEstudio: action.planes
			}

			
        case INFO:
			return {
				...state,
				info: action.info
			}

		case CONJUNTO_PERIODOS:
			return {
				...state,
				conjuntoPeriodos: action.conjuntoPeriodos
			}	

		case LABELS:
			return {
					...state,
				labels: action.labels
			}	

		case ESTRUCTURA_CUSTOMNAMES:
			return {
					...state,
				customNames: action.customNames
			}	
		case PARAMETROS:
			return {
					...state,
				parametros: action.parametros
			}		
		default:
			return state;
	}
}

export default Sistema